import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { CustomFieldsModule } from 'src/app/components/custom-fields/custom-fields.module';
import { SharedDirectivesModule } from 'src/directives/shared-directives.module';

import { AvatarModule } from '../components/avatar/avatar.module';

import { DisplayMicrosoftTeamsMessageComponent } from './display-microsoft-teams-message.component';
import { DisplayMicrosoftTeamsMessageRoutingModule } from './display-microsoft-teams-message.routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DisplayMicrosoftTeamsMessageRoutingModule,
    CustomFieldsModule,
    AvatarModule,
    NgxTippyModule,
    SharedDirectivesModule,
  ],
  declarations: [DisplayMicrosoftTeamsMessageComponent],
})
export class DisplayMicrosoftTeamsMessageModule {}
